import { empresaDataInterface } from "../../pages/Empresa/empresa";

export const bbData: empresaDataInterface = {
    "icon":"https://media.grupoinveste.pt/emp/blendbyte/icon.png",
    "logo_white":"https://media.grupoinveste.pt/emp/blendbyte/horizontal_white.png",
    "color": "rgba(254, 112, 35, 1)",
    "link": "/Blendbyte",
    "header": {
        "website": "https://blendbyte.pt",
        "banner": "https://media.grupoinveste.pt/emp/blendbyte/banner.png",
        "tags": [
            "blendbyte.tags.0", "blendbyte.tags.1", "blendbyte.tags.2", 
        ],
        "name": "blendbyte.name",
        "slogan": "blendbyte.slogan"
    },
    "section1": {
        "img": "https://media.grupoinveste.pt/emp/blendbyte/horizontal_black.png",
        "title_1":"blendbyte.section1.title1",
        "text_1":"blendbyte.section1.text1",
        "text_2":"blendbyte.section1.text2",
        "title_2":"blendbyte.section1.title2",
        "text_3":"blendbyte.section1.text3",
        "text_4":"blendbyte.section1.text4",
    },
    "section2": [
        {
            "title": "blendbyte.section2.0.title",
            "text": [
                "blendbyte.section2.0.text.0", "blendbyte.section2.0.text.1", "blendbyte.section2.0.text.2",  "blendbyte.section2.0.text.3",  "blendbyte.section2.0.text.4"
            ]
        },
        {
            "title": "blendbyte.section2.1.title",
            "text": [
                "blendbyte.section2.1.text.0", "blendbyte.section2.1.text.1", "blendbyte.section2.1.text.2"
            ]
        },
        {
            "title": "blendbyte.section2.2.title",
            "text": [
                "blendbyte.section2.2.text.0", "blendbyte.section2.2.text.1", "blendbyte.section2.2.text.2", "blendbyte.section2.2.text.3", "blendbyte.section2.2.text.4"
            ]
        },
        {
            "title": "blendbyte.section2.3.title",
            "text": [
                "blendbyte.section2.3.text.0", "blendbyte.section2.3.text.1", "blendbyte.section2.3.text.2", "blendbyte.section2.3.text.3"
            ]
        },
        {
            "title": "blendbyte.section2.4.title",
            "text": [
                "blendbyte.section2.4.text.0", "blendbyte.section2.4.text.1", "blendbyte.section2.4.text.2"
            ]
        }
    ],
    "section3": {
        "title": "blendbyte.section3.title",
        "text": "blendbyte.section3.text",
        "link": "https://blendbyte.pt/"
    }
}